import { createRef, useCallback, useState } from "react"
import { useTranslation } from "react-i18next"
import { v4 as uuidv4 } from 'uuid'
import { DinamicFormRefValues, DynamicFormRefProps, DynamicFormRefValues, DynamicRefRef } from "../../../../../../../../components/dynamicFormRef/types"
import { useRefs } from "../../../../../../../../hooks/useReactHookModified"
import { OnlyKeepTwoDecimals } from "../../../../../../../../utils/methods/removeDecimals"
import { removeAllReference } from "../../../../../../../../utils/methods/removedReference"
import { Item } from "../../../../../../../../utils/types/generals"
import { EvidenceActive, OptionActionProps, OptionActionRef, OptionActionSavePayload } from "../../../../../../components/optionActions/types"
import { QuestionClass } from "../../../../contextProvider/provider/types"
import { AnswerFormRef } from "../../question/answer/answerForm"
import { SectionContext } from "../context"
import { typeConfigs } from "./constants"
import { formatOpenConfig } from "./methods"
import { ConfigType, DetailConfig, OptionActionIds, Question, SectionProviderProps } from "./types"

const SectionProvider = ({
    children,
    index: indexSection,
    id: sectionId,
    sectionDefault,
    questionListDefault,
    averagePoints,
    closeModal,
    handleTotalPoints,
    headerConfig,
    isGeneral,
    isSectionConfig,
    sectionAmount,
    totalSectionPoints,
    setTotalSectionPoints,
    setIdSectionIsEditing,
    setModal,
    totalPoints,
    dataHeader,
    optionGroup,
    options,
    updateQuestionList
}: SectionProviderProps) => {
    const { t } = useTranslation()
    const optionRef = createRef<OptionActionRef>()
    const [openOptionAction, setOpenOptionActions] = useState(false)
    const [optionActionDefaultValues, setOptionActionDefaultValues] = useState<OptionActionProps['defaults']>()
    const [optionActionIds, setOptionsActionIds] = useState<OptionActionIds>({})
    const [idToOptionAction, setIdTpOptionAction] = useState('')
    const [cannotSeeConfig, setCannotSeeConfig] = useState({
        actionPlan: false,
        evidence: false,
        reportFolio: false,
        reincidence: false,
    })
    const [detailConfig, setDetailConfig] = useState<DetailConfig>()
    const refSections = useRefs<DynamicRefRef>()
    const refQuestion = useRefs<DynamicRefRef>()
    const refAnswerList = useRefs<AnswerFormRef>()
    const [questionData, setQuestionData] = useState<Record<string, DinamicFormRefValues>>({ id: uuidv4(), notApplicable:false })
    const [answerList, setAnswerList] = useState<any[]>([{ id: uuidv4(), value: '0' }, { id: uuidv4(), value: '0' }])
    const [configGeneral, setConfigGeneral] = useState<string | null>(null)
    const [arrow, setArrow] = useState<string[]>([])
    const [totalQuestionPoints, setTotalQuestionPoints] = useState(0)
    const [questionValuePoints, setQuestionValuePoints] = useState(0)
    const [questionId, setQuestionId] = useState('')
    const [questionActionItemList, setQuestionActionItemList] = useState<Item[]>([])
    const totalPointHeader = Number(dataHeader?.totalPoints ?? 0).toFixed(2)
    const answerListLength = answerList.length
    const questionTemplate = questionData?.questionTemplate
    const option = (questionData?.questionOption as Item)?.value
    const isOptionType = {
        isSimple: option == '1',
        isMultiple: option == '2',
        isFree: option == '3',
        isAffective: option == '4',
    }

    const handleOptions = ({ name, value }: { name: string; value: DinamicFormRefValues }) => {
        if (name == 'questionOption' && option != value?.value) {
            // setQuestionData(prev => ({ ...prev, [name]: value }))
            const option = (value as Item)?.value
            const answerListLocale = getAnswerData()
            const isMulltiple = option == '2'
            const isFree = option == '3'
            const isAffective = option == '4'
            if (!isMulltiple) {
                setConfigGeneral(null)
            }
            if(isAffective){
                const ref2 = refQuestion.refsByKey?.['option']
                if (ref2?.setValues) {
                    ref2?.setValues({ name: 'notApplicable', value: false });
                }
            }
            if (!isFree) {
                let answerListCopy = removeAllReference(answerListLocale)
                const optionGroup = (questionTemplate as Item)?.options
                if (answerListCopy?.length == 1) {
                    answerListCopy.push({ id: uuidv4() })
                }

                if (optionGroup) {
                    answerListCopy = optionGroup.map((template: Item, index: number) => ({
                        ...answerListCopy?.[index] ?? {},
                        config: isMulltiple ? null : answerList?.[index]?.config,
                        id: uuidv4(),
                        notApplicable:isAffective ? false : answerListCopy?.[index]?.notApplicable,
                        value: answerListCopy?.[index]?.value || '0',
                        answer: isAffective ? {
                            text: template.description,
                            file: template?.iconUrl
                        } : template.description,
                    }))
                } else {
                    answerListCopy = answerListCopy.map((answer, index) => ({
                        ...answer,
                        config: isMulltiple ? null : answerList?.[index]?.config,
                        id: uuidv4(),
                        notApplicable:isAffective ? false : answerListCopy?.[index]?.notApplicable,
                        value: answerListCopy?.[index]?.value || '0',
                        answer: isAffective ? {
                            text: answer.answer ?? '',
                            file: ''
                        } : answer?.answer?.text ?? answer?.answer
                    }))
                }


                setAnswerList(answerListCopy)
            }

            if (isFree) {
                // remueve la plantilla
                setQuestionData(prev => ({
                    ...prev,
                    id: uuidv4(),
                    questionTemplate: null,
                    notApplicable: false
                }))
                const firstAnswer = answerListLocale.splice(0, 1)?.map((answer, index) => ({
                    ...answer,
                    config: answerList?.[index]?.config,
                    id: uuidv4(),
                    notApplicable:false,
                    answer: answer?.answer?.text ?? answer?.answer
                }))
                handleAnswerPoints({ externAnswerList: firstAnswer })
                setAnswerList(firstAnswer)
            }
        }
    }

    const handleQuestionTemplate = ({ name, value }: { name: string; value: DinamicFormRefValues }) => {
        if (name == 'questionTemplate') {
            // setQuestionData(prev => ({ ...prev, [name]: value }))
            setAnswerList(formatAnswer(value))
        }
    }
    const removeActions = ({ answer }: { answer: any[]; question?: QuestionClass }) => {
        let answerCopy = removeAllReference(answer)

        if (isOptionType.isMultiple) {
            return answerCopy.map(answer => ({
                ...answer,
                action: undefined
            }))
        }
        return answer
    }

    const handleAnswerPoints = ({ externAnswerList, notCount }: { externAnswerList?: any[]; notCount?: boolean }) => {
        const answerList = externAnswerList || getAnswerData()
        const total = OnlyKeepTwoDecimals({ value: Number(answerList.filter(answer => !!answer?.switchOption).reduce((count, value) => count + Number(value.value ?? 0), 0)) })
        if (!notCount) {
            setTotalQuestionPoints(total)
        }
        return total
    }

    const onChangeQuestionnaire: DynamicFormRefProps['onChange'] = (payload) => {
        const name = (payload?.current ?? '') as string
        const value = payload?.[name] as DinamicFormRefValues
        handleOptions({ name, value })
        handleQuestionTemplate({ name, value })
        setQuestionData(prev => ({ ...prev, [name]: value }))
    }

    const onChangeAnswer: (payload: { payload: { current: any, [x: string]: DynamicFormRefValues }; id: string }) => void = ({ payload, id }) => {
        const name = (payload?.current ?? '') as string
        const ref = refAnswerList?.refsByKey?.[id]

        const ref2 = refQuestion.refsByKey?.['option']
        if (ref2?.getValues) {
            const values = ref2.getValues();
            const notApplicable = values?.notApplicable;
                       
            if(payload?.current == 'notApplicable' && payload?.notApplicable == true && !notApplicable){
                if (ref?.setValues) {
                    ref?.setValues({ name: 'switchOption', value: false });
                    ref?.setValues({ name: 'value', value: '0.00' });
                    ref?.setValues({ name: 'action', value: null });
                }
                if (ref2?.setValues) {
                    ref2?.setValues({ name: 'notApplicable', value: true });
                }
                handleAnswerPoints({})
    
            }

            if(payload?.current == 'notApplicable' && payload?.notApplicable == true && notApplicable){
                if (ref?.setValues) {
                    ref?.setValues({ name: 'notApplicable', value: false });
                }
            }

            if(payload?.current == 'notApplicable' && payload?.notApplicable == false && notApplicable){
                if (ref2?.setValues) {
                    ref2?.setValues({ name: 'notApplicable', value: false });
                }
            }
        }
        
        if (['value', 'switchOption'].includes(name)) {
            const total = handleAnswerPoints({ notCount: true })
            const pointToCompare = isSectionConfig ? Number(sectionDefault?.sectionPoints ?? 0) : totalPointHeader
            const pointToAdd = isSectionConfig ? Number(totalSectionPoints?.[sectionId] ?? 0) : Number(averagePoints - questionValuePoints)
            const totalAnswersPlusSection = OnlyKeepTwoDecimals({ value: Number((total + pointToAdd)) })

            if (totalAnswersPlusSection > Number(pointToCompare)) {
                const ref = refAnswerList?.refsByKey?.[id]
                if (ref?.setValues) {
                    if (name == 'value') {
                        ref?.setValues({ name: 'value', value: String(payload?.oldValue || 0) })
                    }
                    if (name == 'switchOption') {
                        ref?.setValues({ name: 'switchOption', value: false })
                    }
                }
            }
            if (name != 'value' || (name == 'value' && !isNaN(Number(payload?.['value'])) && Number(payload?.['value']) >= 0)) {
                handleAnswerPoints({})
            }
        }
    }

    const onBlurAnswer: (payload: { payload: { current: any, [x: string]: DynamicFormRefValues }; id: string }) => void = ({ payload, id }) => {
        const name = (payload?.current ?? '') as string

        if (name == 'value' && (isNaN(Number(payload?.['value'])) || Number(payload?.['value']) < 0)) {
            const ref = refAnswerList?.refsByKey?.[id]
            if (ref?.setValues) {
                if (name == 'value') {
                    ref?.setValues({ name: 'value', value: String(0) })
                }
            }
        }
    }

    const getAnswerData = () => {
        const recoveredAnswerData: any[] = []
        for (const answerData of answerList) {
            const ref = refAnswerList?.refsByKey?.[answerData.id]

            if (ref?.getAnswerData) {
                recoveredAnswerData.push({
                    ...ref?.getAnswerData(),
                    config: answerData.config
                })
            }
        }

        return (recoveredAnswerData)
    }
    const getQuestionData = () => {
        const ref = refQuestion.refsByKey?.['option']
        const ref2 = refQuestion.refsByKey?.['option']
        let notApplicable;
        if (ref2?.getValues) {
            const values = ref2.getValues();
            notApplicable = !!values?.notApplicable;
        }
        if (ref?.getValues) {
            return { ...ref.getValues(), config: questionData.config, questionOption: questionData.questionOption, notApplicable }
        }

        return {}
    }

    const addAnswer = () => {
        const asnwers = removeAllReference(answerList)
        asnwers.push({ id: uuidv4() })
        setAnswerList(asnwers)

    }

    const removeAnswer = ({ id }: { id: string }) => {
        const answerList = getAnswerData()
        const list = answerList.filter(answer => answer?.id != id)
        handleAnswerPoints({ externAnswerList: list })
        setAnswerList(list)

    }

    const removeQuestion = useCallback(({ id }: { id: string }) => {
        setModal(prev => ({
            ...prev,
            open: true,
            title: '¿Está seguro que desea eliminar esta pregunta?',
            description: 'Al eliminar la pregunta, se perderán las configuraciones realizadas',
            cancel: closeModal,
            confirm: () => {
                const findQuestion = questionListDefault?.find(question => question.id == id)
                setTotalSectionPoints(prev => ({ ...prev, [sectionId]: Number(prev?.[sectionId] ?? 0) - Number(findQuestion?.totalQuestionPoints) }))
                handleTotalPoints({ totalPoints: Number(totalPoints) - Number(findQuestion?.totalQuestionPoints), addToAverage: true })
                const filterQuestionList = questionListDefault?.filter(question => question.id != id)
                sectionAmount({ id: sectionId, questionAmount: filterQuestionList?.length ?? 0 })
                updateQuestionList({ id: sectionId, index: 1, question: filterQuestionList || [], totalSectionPoints: Number(totalSectionPoints?.[sectionId] ?? 0) - Number(findQuestion?.totalQuestionPoints) })

                closeModal()
            }
        }))
    }, [questionListDefault])

    const formatAnswer = (questionTemplate: DinamicFormRefValues) => {
        if (!!(questionTemplate as Item)?.options) {
            const answerListLocale = getAnswerData()
            return (questionTemplate as Item)?.options?.map((template: Item, index: number) => {

                const answerItem = answerListLocale?.[index]
                return ({
                    id: uuidv4(),
                    config: answerList?.[index]?.config,
                    answer: isOptionType.isAffective ? {
                        text: template.description,
                        file: template?.iconUrl
                    } : template.description,
                    action: answerItem?.action,
                    switchOption: Boolean(answerItem?.switchOption),
                    value: answerItem?.value || answerList?.[index]?.value || '0',
                })
            })
        }

        return answerList
    }

    const getQuestionForm = () => {
        const answer = getAnswerData()
        const question = getQuestionData()
        return { answer, question: { ...question, questionOption: questionData.questionOption } as QuestionClass }
    }

    const keepSafeQuestionData = () => {
        const { answer } = getQuestionForm()
        setAnswerList(answer)
        cancelEdit()
    }

    const resetQuestionData = () => {
        setAnswerList([{ id: uuidv4(), value: '0' }, { id: uuidv4(), value: '0' }])
        setQuestionData({ id: uuidv4(), notApplicable:false })
        setQuestionActionItemList([])
    }

    const validateAnswerData = () => {
        let error = false
        const answers = getAnswerData()
        const someAnswerHaveActiveConfig = answers.some(answer => !!answer?.activeReeportFolio)
        const existedGeneralConfig = !!configGeneral && !!Object.values(JSON.parse(configGeneral ?? '{}'))?.length
        if (isOptionType?.isMultiple && existedGeneralConfig && !someAnswerHaveActiveConfig) {
            return { error: true, title: 'Se encontró una configuración', description: 'Debe activar la configuración en al menos una respuesta.' }
        }

        for (const answerData of answerList) {
            const ref = refAnswerList?.refsByKey?.[answerData.id]
            if (ref?.validate) {
                const response = ref.validate()
                if (response) {
                    error = true
                    break
                }
            }
        }

        return { error }
    }

    const validateQuestionData = (): { error: boolean; title?: string; description?: string } => {
        const questionRef = refQuestion.refsByKey?.['option']
        if (questionRef?.validate && questionRef.validate()) {
            return { error: true }
        }
        const existErrorInAnswer = validateAnswerData()
        if (existErrorInAnswer?.error) {
            return existErrorInAnswer
        }

        return { error: false }
    }

    const saveQuestion = () => {
        const { answer, question } = getQuestionForm()
        let newData: Question = {}
        let questionListCopy = removeAllReference(questionListDefault || [])
        if (questionId) {
            let questionIndex = questionListCopy.findIndex(item => item.id == questionId)
            if (questionIndex > -1) {
                newData = {
                    id: questionId,
                    answer: removeActions({ answer, question }),
                    question,
                    configGeneral,
                    totalQuestionPoints
                }
                questionListCopy[questionIndex] = newData
            }
        } else {
            newData = {
                id: uuidv4(),
                answer,
                question,
                configGeneral,
                totalQuestionPoints
            }

            questionListCopy.push(newData)
        }
        const response = validateQuestionData()
        const total = Number(averagePoints - questionValuePoints) + Number(totalQuestionPoints)
        const isValidatePoint = isSectionConfig || (!isSectionConfig && total <= Number(totalPointHeader))
        if (!response?.error && isValidatePoint) {
            sectionAmount({ id: sectionId, questionAmount: questionListCopy.length })
            resetQuestionData()
            setQuestionId('')
            setTotalSectionPoints(prev => ({ ...prev, [sectionId]: Number(prev?.[sectionId] ?? 0) + Number(totalQuestionPoints) }))
            setTotalQuestionPoints(0)
            setQuestionValuePoints(0)
            updateQuestionList({ id: sectionId, index: 1, question: questionListCopy, totalSectionPoints: Number(totalQuestionPoints) + Number(totalSectionPoints?.[sectionId] ?? 0) })
            handleTotalPoints({ totalPoints: Number(totalPoints) + Number(totalQuestionPoints), addToAverage: true })
            setConfigGeneral(null)
            setIdSectionIsEditing('')
            return
        }
        setModal(prev => ({
            ...prev,
            open: true,
            title: response?.title ?? 'Se encontraron campos con errores y no se puede guardar la pregunta',
            description: response?.description ?? ''
        }))
    }

    const cancelEdit = () => {
        resetQuestionData()
        setQuestionId('')
        setTotalQuestionPoints(0)
        setQuestionValuePoints(0)
        setTotalSectionPoints(prev => ({ ...prev, [sectionId]: Number(prev?.[sectionId] ?? 0) + questionValuePoints }))
        handleTotalPoints({ totalPoints: Number(totalPoints) + Number(questionValuePoints) })
        setIdSectionIsEditing('')
        window.location.hash = ''
    }

    const editQuestion = ({ id }: { id: string }) => {
        window.location.hash = ``
        setIdSectionIsEditing(sectionId)
        if (questionId != id) {
            if (questionId) {
                setTotalSectionPoints(prev => ({ ...prev, [sectionId]: Number(prev?.[sectionId] ?? 0) + questionValuePoints }))
                handleTotalPoints({ totalPoints: Number(totalPoints) + Number(questionValuePoints) })
            }
            const questionFound = questionListDefault?.find(question => question.id == id)
            fillListOfQuestionnairesToAction({ question: questionListDefault || [], id })
            const questionPoints = Number(questionFound?.totalQuestionPoints)
            setQuestionId(id)
            setAnswerList(() => questionFound?.answer ?? [])
            setQuestionData(questionFound?.question)
            setTotalQuestionPoints(questionPoints)
            setQuestionValuePoints(questionPoints)
            setConfigGeneral(questionFound?.configGeneral ?? null)
            setTotalSectionPoints(prev => ({ ...prev, [sectionId]: Number(prev?.[sectionId] ?? 0) - (questionPoints ?? 0) }))
            handleTotalPoints({ totalPoints: Number(totalPoints) - Number(questionPoints) })
            window.location.hash = `section-${sectionId}`
        }
    }

    const answerOrder = (list: any[]) => {
        const answers = getAnswerData()
        setAnswerList(() => list.map(item => {
            const answerFind = answers.find(answer => answer.id == item?.id)
            return answerFind || item
        }))
    }

    const questionOrder = (list: any[]) => {
        updateQuestionList({ id: sectionId, index: 1, question: list })
    }

    const fillListOfQuestionnairesToAction = ({ question, id }: { question: any[]; id: string }) => {
        const questionIndex = question.findIndex(question => question.id == id)
        const questionActionItemList = question?.slice(Number(questionIndex) + 2)?.map(question => ({
            id: question.id,
            label: question.question.questionText,
            value: question.question.id,
        }) as Item)

        setQuestionActionItemList(questionActionItemList)
    }

    const saveConfigInOptionList = (payload: OptionActionSavePayload) => {
        const stringPayload = JSON.stringify(payload)
        /* if (optionActionIds.section === null) {
            setSectionData(prev => ({ ...prev ?? {}, config: stringPayload }))
        } else */ if (optionActionIds.questionData === null || Boolean(optionActionIds.questionList?.length)) {
            const id = optionActionIds.questionList?.length ? optionActionIds.questionList[0] : null
            if (id) {
                const questionList = structuredClone(questionListDefault ?? [])
                const findQuestionIndex = questionList.findIndex(question => question.id == id)
                questionList[findQuestionIndex].question = { ...questionList[findQuestionIndex].question, config: stringPayload }
                updateQuestionList({ id: sectionId, index: 1, question: questionList })
                // setQuestionList(questionList)
            } else {
                setQuestionData(prev => ({ ...prev ?? {}, config: stringPayload }))
            }
        } else if (Boolean(optionActionIds.answerData?.length) || Boolean(optionActionIds.answerList?.length)) {
            const idList = (optionActionIds.answerData || optionActionIds.answerList) as Array<string>
            const [answerId, questionId] = idList
            if (questionId) {
                const questionList = structuredClone(questionListDefault ?? [])
                const findQuestionIndex = questionList.findIndex(question => question.id == questionId)
                const questionFound = questionList[findQuestionIndex]
                const findAnswerIndex = questionFound?.answer?.findIndex((answer) => answer.id == answerId)
                if (findAnswerIndex || findAnswerIndex == 0) {
                    const answerFound = questionFound?.answer?.[findAnswerIndex]
                    questionList[findQuestionIndex].answer[findAnswerIndex] = { ...answerFound, config: stringPayload }
                }
                updateQuestionList({ id: sectionId, index: 1, question: questionList })
                // setQuestionList(questionList)
            } else {
                const findAnswerIndex = answerList.findIndex(answer => answer.id == answerId)
                answerList[findAnswerIndex] = { ...answerList[findAnswerIndex], config: stringPayload }
                setAnswerList(answerList)
            }
        } else if (optionActionIds.answerDataGeneral === null || Boolean(optionActionIds.answerDataGeneral?.length)) {
            const id = optionActionIds.answerDataGeneral?.length ? optionActionIds.answerDataGeneral[0] : null
            if (Boolean(id)) {
                const questionList = structuredClone(questionListDefault ?? [])
                const findQuestionIndex = questionList.findIndex(question => question.id == id)
                questionList[findQuestionIndex] = { ...questionList[findQuestionIndex], configGeneral: stringPayload }
                updateQuestionList({ id: sectionId, index: 1, question: questionList })
                // setQuestionList(questionList)
            } else {
                setConfigGeneral(stringPayload)
            }
        }
    }

    const saveConfigurations = (payload: OptionActionSavePayload) => {
        setArrow([])
        saveConfigInOptionList(payload)
        setOpenOptionActions(false)
        setOptionsActionIds({})
        setIdTpOptionAction('')
        setDetailConfig(undefined)
        setOptionActionDefaultValues(undefined)
    }

    const openConfig = ({ id, name }: { id: Array<string> | null; name: ConfigType }) => {
        const answerList = getAnswerData()
        if (typeConfigs.answerDataGeneral == name && Boolean(id?.length)) {
            const idList = (id) as Array<string>
            const findQuestion = questionListDefault?.find(question => question.id == idList[0])
            if (findQuestion?.question?.questionOption?.value == '2' && !findQuestion?.answer?.some(answer => answer?.activeReeportFolio)) {
                setModal(prev => ({
                    ...prev,
                    open: true,
                    title: 'Active la configuración en al menos una respuesta desde la edición.',
                    description: '',
                    cancel: undefined,
                    close: undefined,
                    confirm: closeModal
                }))
                return
            }
        }
        const { canSeeConfig, optionAction, detailConfig, optionData } = formatOpenConfig({ answerList, configGeneral, id, indexSection, name, questionData, questionListDefault })
        if (id) {
            setArrow(id)
        }
        setIdTpOptionAction(optionAction)
        setCannotSeeConfig(canSeeConfig)
        setDetailConfig(detailConfig)
        setOptionActionDefaultValues(optionData)
        setOptionsActionIds({ [name]: id })
        setOpenOptionActions(true)
    }

    const checkQuestionOrAnswerHaveEvidence: EvidenceActive = ({ name }) => {
        if (name == 'evidences') {
            let configExisted = validateExistConfig()

            if (configExisted) {
                const questionForm = Boolean(optionActionIds.questionData === null)
                const questionDetailList = Boolean(optionActionIds.questionList?.length)

                const handleActivating = optionRef.current?.handleActivatingOption
                setModal(prev => ({
                    ...prev,
                    open: true,
                    title: t('general.confirmation'),
                    description: t(`Questionarie.modal.${questionForm || questionDetailList ? 'activeByQuestion' : 'activeByOptions'}`),
                    cancel: () => {
                        if (handleActivating) {
                            handleActivating({ name, value: false })
                        }
                        closeModal()
                    },
                    confirm: () => {
                        removeConfig()
                        closeModal()
                    }
                }))
            }
        }
    }

    const validateExistConfig = () => {
        const answerData = Boolean(optionActionIds.answerData?.length)
        const answerlistDetail = Boolean(optionActionIds.answerList?.length)
        const questionForm = Boolean(optionActionIds.questionData === null)
        const questionDetailList = Boolean(optionActionIds.questionList?.length)
        const answerGeneralDetaail = Boolean(optionActionIds.answerDataGeneral?.length)
        const answerGeneralForm = optionActionIds.answerDataGeneral === null
        let configExisted = false
        if (answerData || answerGeneralForm) {
            const questionConfig = JSON.parse((questionData?.config as string) ?? '{}')
            configExisted = Boolean(questionConfig?.evidenceData?.length)
        }

        if (questionForm) {
            if (isOptionType.isMultiple) {
                configExisted = Boolean(JSON.parse(configGeneral ?? '')?.evidenceData?.length)
            } else {
                configExisted = answerList.some(answer => JSON.parse((answer?.config as string) ?? '{}')?.evidenceData?.length)
            }
        }

        if (questionDetailList) {
            const question = questionListDefault?.find(question => question.id == optionActionIds.questionList?.[0])
            if (question?.configGeneral) {
                configExisted = Boolean(JSON.parse(question?.configGeneral ?? '{}')?.evidenceData?.length)
            } else {
                configExisted = Boolean(question?.answer?.some(answer => JSON.parse((answer?.config as string) ?? '{}')?.evidenceData?.length))
            }
        }

        if (answerGeneralDetaail || answerlistDetail) {
            const id = optionActionIds.answerDataGeneral?.[0] ?? optionActionIds.answerList?.[1]
            const question = questionListDefault?.find(question => question.id == id)
            const questionConfig = JSON.parse((question?.question?.config as string) ?? '{}')
            configExisted = Boolean(questionConfig?.evidenceData?.length)
        }
        return configExisted
    }

    const removeConfig = () => {
        const answerData = Boolean(optionActionIds.answerData?.length)
        const answerlistDetail = Boolean(optionActionIds.answerList?.length)
        const questionForm = Boolean(optionActionIds.questionData === null)
        const questionDetailList = Boolean(optionActionIds.questionList?.length)
        const answerGeneralDetaail = Boolean(optionActionIds.answerDataGeneral?.length)
        const answerGeneralForm = optionActionIds.answerDataGeneral === null

        if (answerData || answerGeneralForm) {
            const questionConfig = JSON.parse(questionData?.config as string ?? '{}')
            questionData.config = JSON.stringify({ ...questionConfig, evidenceData: undefined })
            setQuestionData(questionData)
        }

        if (questionForm) {
            if (isOptionType.isMultiple) {
                setConfigGeneral(JSON.stringify({
                    ...JSON.parse(configGeneral ?? ''),
                    evidenceData: undefined
                }))
            } else {
                setAnswerList(answerList.map(answer => ({ ...answer, config: JSON.stringify({ ...JSON.parse((answer?.config as string) ?? '{}'), evidenceData: undefined }) })))
            }
        }

        if (questionDetailList) {
            const questionList = structuredClone(questionListDefault ?? [])
            const questionIndex = questionList?.findIndex(question => question.id == optionActionIds.questionList?.[0])
            const question = questionList?.[questionIndex]
            if (question?.configGeneral) {
                question.configGeneral = JSON.stringify({ ...JSON.parse(question?.configGeneral ?? '{}'), evidenceData: undefined })
            } else {
                question.answer = question?.answer?.map(answer => ({ ...answer, config: JSON.stringify({ ...JSON.parse((answer?.config as string) ?? '{}'), evidenceData: undefined }) }))
            }
            updateQuestionList({ id: sectionId, index: 1, question: questionList })
            // setQuestionList(questionList)
        }

        if (answerGeneralDetaail || answerlistDetail) {
            const questionList = structuredClone(questionListDefault ?? [])
            const id = optionActionIds.answerDataGeneral?.[0] ?? optionActionIds.answerList?.[1]
            const questionIndex = questionList.findIndex(question => question.id == id)
            const question = questionList[questionIndex]
            if (question.question?.config) {
                question.question.config = JSON.stringify({ ...JSON.parse((question?.question?.config as string) ?? '{}'), evidenceData: undefined })
            }
            updateQuestionList({ id: sectionId, index: 1, question: questionList })
            // setQuestionList(questionList)
        }
    }

    // useEvent({ eventName: Events.editQuestion, callback: editQuestion })
    // useEvent({ eventName: Events.orderQuestion, callback: questionOrder })
    // useEvent({ eventName: Events.removeQuestion, callback: removeQuestion })
    // useEvent({ eventName: Events.openQuestion, callback: openConfig })

    return (
        <SectionContext.Provider
            value={{
                checkQuestionOrAnswerHaveEvidence,
                onChangeQuestionnaire,
                keepSafeQuestionData,
                saveConfigurations,
                onChangeAnswer,
                removeQuestion,
                // setSectionData,
                questionOrder,
                saveQuestion,
                removeAnswer,
                editQuestion,
                answerOrder,
                cancelEdit,
                openConfig,
                addAnswer,
                setModal,
                arrow,
                questionValuePoints,
                optionActionDefaultValues,
                detailConfig,
                questionActionItemList,
                totalQuestionPoints,
                totalSectionPoints: totalSectionPoints?.[sectionId] ?? 0,
                idToOptionAction,
                questionTemplate,
                answerListLength,
                optionActionIds,
                optionGroup,
                options,
                openOptionAction,
                headerConfig,
                optionRef,
                cannotSeeConfig,
                refAnswerList,
                questionData,
                isOptionType,
                // sectionData,
                onBlurAnswer,
                refSections,
                refQuestion,
                questionId,
                answerList,
                isGeneral,
                option
            }}
        >
            {children}
        </SectionContext.Provider>
    )
}

export { SectionProvider }
